module.exports = __webpack_public_path__ + "img/VERS4.18a88cfd.png";